import produce from 'immer';

import {
	SET_COOKIE_CONFIRMATION_FULFILLED
} from '../constants/cookies.actions';
import { COOKIE_DISCLAIMER_TOKEN } from '../constants/tokens';
import { getCookie } from '../helpers/cookies';

const cookieReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case (SET_COOKIE_CONFIRMATION_FULFILLED): {
				draft.value = action.payload.value;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		value: getCookie(COOKIE_DISCLAIMER_TOKEN)
	}
);

export default cookieReducer;
